import { Component, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-dial-pad',
    templateUrl: './dial-pad.component.html',
    styleUrls: ['./dial-pad.component.scss']
})
export class DialPadComponent {

    @Output() digitPressed = new EventEmitter<string>();

    // `hold` is the character emitted on a long press (e.g. hold "0" to type "+").
    buttons: { digit: string, letters: string, hold?: string }[] = [
        { digit: '1', letters: '' },
        { digit: '2', letters: 'ABC' },
        { digit: '3', letters: 'DEF' },
        { digit: '4', letters: 'GHI' },
        { digit: '5', letters: 'JKL' },
        { digit: '6', letters: 'MNO' },
        { digit: '7', letters: 'PQRS' },
        { digit: '8', letters: 'TUV' },
        { digit: '9', letters: 'WXYZ' },
        { digit: '*', letters: '' },
        { digit: '0', letters: '+', hold: '+' },
        { digit: '#', letters: '' }
    ];

    private pressTimer: any = null;
    private longPressFired = false;
    private static readonly LONG_PRESS_MS = 500;

    onPressStart(btn: { digit: string, hold?: string }): void {
        this.longPressFired = false;
        if (!btn.hold) { return; }
        this.pressTimer = setTimeout(() => {
            this.longPressFired = true;
            this.pressTimer = null;
            this.digitPressed.emit(btn.hold);
        }, DialPadComponent.LONG_PRESS_MS);
    }

    onPressEnd(): void {
        if (this.pressTimer) {
            clearTimeout(this.pressTimer);
            this.pressTimer = null;
        }
    }

    onDigitClick(btn: { digit: string }): void {
        // A long press already emitted the `hold` value — swallow the trailing click.
        if (this.longPressFired) {
            this.longPressFired = false;
            return;
        }
        this.digitPressed.emit(btn.digit);
    }
}
